import { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import comment_img1 from '../../asstes/images/comment_img1.png';
import comment_img2 from '../../asstes/images/comment_img2.png';
import comment_img3 from '../../asstes/images/comment_img3.png';
const testimonials = [
        {
            name: 'Stephanie',
            team: 'Team Paws',
            text: "Since moving to NYC, I'd been missing that presence of a dog in my life. Finally, your pack walk with Asha gave me the boost to say – 'OK, I'm ready, let's do this!' Two weeks later, we brought Winnie home.",
            imageUrl: comment_img2, // replace with actual image URL
            // badge: 'Adopted Winnie',
        },
        {
            name: 'Angela',
            team: 'Team Social',
            text: "I love dogs, but am not in a place to have my own, so Social Paws is a great opportunity to enjoy their company occasionally [and help their owners at the same time!] ",
            imageUrl: comment_img1, // replace with actual image URL
            // badge: 'Adopted Winnie',
        },
        {
            name: 'saved$800',
            team: '',
            text: "Social Paws is amazing. I saved $800 on dog-boarding costs while I was in Mexico w/ my son & got to know that Darci was being spoiled & loving it!",
            imageUrl: comment_img3, // replace with actual image URL
            // badge: 'Adopted Winnie',
        },
        // Add more testimonials here as needed
    ];

export default function TestimonialCarousel() {
  const [selected, setSelected] = useState(0);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [pageHidden, setPageHidden] = useState(document.hidden);
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  useEffect(() => {
    const visibilityChanged = () => setPageHidden(document.hidden);
    document.addEventListener('visibilitychange', visibilityChanged);
    return () => document.removeEventListener('visibilitychange', visibilityChanged);
  }, []);

  useEffect(() => {
    if (hovered || focused || pageHidden || reduceMotion) return;
    const timer = setTimeout(() => setSelected(index => (index + 1) % testimonials.length), 6000);
    return () => clearTimeout(timer);
  }, [selected, hovered, focused, pageHidden, reduceMotion]);

  return <section className="home-testimonials" aria-label="Community stories"
    onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
    onFocusCapture={() => setFocused(true)}
    onBlurCapture={event => { if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false); }}>
    <div className="testimonial-slides" aria-live={hovered || focused ? 'polite' : 'off'}>
      {testimonials.map((item, index) => <div key={index} className="testimonial-content" aria-hidden={selected !== index}>
        <img src={item.imageUrl} alt=""/>
        <div><h2>{item.name}</h2><small>{item.team}</small><blockquote>{item.text}</blockquote></div>
      </div>)}
    </div>
    <div className="testimonial-controls" role="group" aria-label="Choose a community story">
      <button type="button" className="testimonial-arrow" aria-label="Previous story" onClick={() => setSelected(index => (index - 1 + testimonials.length) % testimonials.length)}><ChevronLeftIcon/></button>
      {testimonials.map((item, index) => <button type="button" key={index} aria-label={`Read story ${index + 1}`} aria-pressed={selected === index} onClick={() => setSelected(index)}><span/></button>)}
      <button type="button" className="testimonial-arrow" aria-label="Next story" onClick={() => setSelected(index => (index + 1) % testimonials.length)}><ChevronRightIcon/></button>
    </div>
  </section>;
}
